// Single source of truth for the game's identity and build version. The UI
// reads these so the version is always visible on screen, and the save system
// stamps saves with VERSION for future migrations.

export const GAME_NAME = 'GÖKTÜRK';
export const VERSION = '0.19.0';
export const SAVE_KEY = 'eons.save.v1'; // unchanged so existing playtest saves survive

// One-line tagline shown on the title/HUD.
export const TAGLINE = 'Bozkırın tozundan göğün hükümdarlığına.';

// Opening narrative shown once on the title screen.
export const STORY =
  'Ebedi mavi gök altında, bozkırda bir avuç otağ. Sen halkı yönetmezsin, ' +
  'onlara yol gösteren göğün iradesisin. Çağ çağ yüksel, düşersen küllerinden ' +
  'daha güçlü dön, ve gök bir tavan değil dönülecek yurt olana dek yıldızlara açıl.';
